import { convertValueFromLogarithmicBehaviour } from '../utils';

const sliderNormal = {
    amount: {
        value: 10000,
        min: 1000,
        max: 30000,
        minAmountDue: 12682.64,
        maxAmountDue: 15048.42,
    },
    payment: {
        value: 175,
        min: 175,
        max: 475,
        minPaymentDue: 152.46,
        maxPaymentDue: 179.96,
    },
};

const slidersOneMinute = {
    amount: {
        value: 2000,
        min: 1000,
        max: 5000,
        minAmountDue: 2281.09,
        maxAmountDue: 2655.73,
    },
    payment: {
        value: 45,
        min: 45,
        max: 95,
        minPaymentDue: 43.14,
        maxPaymentDue: 93.81,
    },
};

export const initialSliderNormal = {
    amount: {
        /*
        initialValue: {
            real: convertValueFromLogarithmicBehaviour({ 
                currentValue: sliderNormal["amount"]["value"],
                min: sliderNormal["amount"]["min"],
                max: sliderNormal["amount"]["max"],
                step: 10 
            }, 5),
            shown: sliderNormal["amount"]["value"],
        },
        */
        currentValue: {
            real: convertValueFromLogarithmicBehaviour({ 
                currentValue: sliderNormal["amount"]["value"],
                min: sliderNormal["amount"]["min"],
                max: sliderNormal["amount"]["max"],
                step: 10 
            }, 5),
            shown: sliderNormal["amount"]["value"],
        },
        min: sliderNormal["amount"]["min"],
        max: sliderNormal["amount"]["max"],
        step: 1000,
        reinitialize: false,
    },
    payment: {
        /*
        initialValue: {
            real: convertValueFromLogarithmicBehaviour({ 
                currentValue: sliderNormal["payment"]["value"],
                min: sliderNormal["payment"]["min"],
                max: sliderNormal["payment"]["max"],
                step: 1 
            }, 5),
            shown: sliderNormal["payment"]["value"],
        },
        */
        currentValue: {
            real: convertValueFromLogarithmicBehaviour({ 
                currentValue: sliderNormal["payment"]["value"],
                min: sliderNormal["payment"]["min"],
                max: sliderNormal["payment"]["max"],
                step: 1 
            }, 5),
            shown: sliderNormal["payment"]["value"],
        },
        min: sliderNormal["payment"]["min"],
        max: sliderNormal["payment"]["max"],
        step: 5,
        reinitialize: false,
        frontLayer: {},
    },
}

export const initialSliderOneMinute = {
    amount: {
        initialValue: {
            real: convertValueFromLogarithmicBehaviour({ 
                currentValue: slidersOneMinute["amount"]["value"],
                min: slidersOneMinute["amount"]["min"],
                max: slidersOneMinute["amount"]["max"],
                step: 10 
            }, 5),
            shown: slidersOneMinute["amount"]["value"],
        },
        currentValue: {
            real: convertValueFromLogarithmicBehaviour({ 
                currentValue: slidersOneMinute["amount"]["value"],
                min: slidersOneMinute["amount"]["min"],
                max: slidersOneMinute["amount"]["max"],
                step: 10 
            }, 5),
            shown: slidersOneMinute["amount"]["value"],
        },
        min: slidersOneMinute["amount"]["min"],
        max: slidersOneMinute["amount"]["max"],
        step: 1000,
        reinitialize: false,
    },
    payment: {
        initialValue: {
            real: convertValueFromLogarithmicBehaviour({ 
                currentValue: slidersOneMinute["payment"]["value"],
                min: slidersOneMinute["payment"]["min"],
                max: slidersOneMinute["payment"]["max"],
                step: 1 
            }, 5),
            shown: slidersOneMinute["payment"]["value"],
        },
        currentValue: {
            real: convertValueFromLogarithmicBehaviour({ 
                currentValue: slidersOneMinute["payment"]["value"],
                min: slidersOneMinute["payment"]["min"],
                max: slidersOneMinute["payment"]["max"],
                step: 1 
            }, 5),
            shown: slidersOneMinute["payment"]["value"],
        },
        min: slidersOneMinute["payment"]["min"],
        max: slidersOneMinute["payment"]["max"],
        step: 5,
        reinitialize: false,
        frontLayer: {},
    },
}